// Translations
import message from '../sections/message/translations/ua'

// Translation: Error > Landing (Ukrainian)
export default Object.freeze({
	sections: { message }
})
